import LoadingSpinner from '../elements/loading-spinner';
var WPAPI = require( '../../wpapi/wpapi.js' );
const { __, _x, _n, _nx } = wp.i18n;

var wpr = new WPAPI({
	endpoint: wpApiSettings.root,
	nonce: wpApiSettings.nonce,
});

class SuggestedListSettings extends wp.element.Component {
  constructor( props ) {
    super( props );
    this.state = {
			wants_to_be_reviewer: false,
			wants_to_be_responsible: false,
			isNominatedReviewer: false,
			isNominatedResponsible: false,
			error: null,
			errorMsg: null,
			isLoading: true,
    };
		this.handleChange = this.handleChange.bind( this );
		this.handleSubmit = this.handleSubmit.bind( this );
  };

	componentDidMount() {
		wpr.users().me().then(res => {
			this.setState( {
				isLoading: false,
				wants_to_be_reviewer: res.meta._iportal_wants_to_be_reviewer,
				wants_to_be_responsible: res.meta._iportal_wants_to_be_responsible,
				isNominatedReviewer: 'state_nominated_reviewer' in res.achievements,
				isNominatedResponsible: 'state_nominated_responsible' in res.achievements,
			} );
		} )
       .catch(error => this.setState({
         error: 'GENERAL',
				 errorMsg: error.message,
         isLoading: false,
       }));
	};

	initLoading() {
		this.setState( {
			error: null,
			errorMsg: null,
			isLoading: true,
		} );
	};

  handleChange( event ) {
		const target = event.target;
		const name = target.name;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		this.setState( {
			[name]: value,
		} );
	};

  handleSubmit( event ) {
    event.preventDefault();
		this.initLoading();
		wpr.users().me().auth().update(
			{ meta: {
				'_iportal_wants_to_be_reviewer': this.state.wants_to_be_reviewer,
				'_iportal_wants_to_be_responsible': this.state.wants_to_be_responsible,
			} }
		).then( data => {
			this.setState( {
				isLoading: false,
			} );
		} )
			.catch(error => this.setState({
				error: 'GENERAL',
				errorMsg: error.message,
				isLoading: false,
			}));
	};

	render() {
		return (
			<form method="get" className={this.state.isLoading ? 'form--loading' : ''} onSubmit={this.handleSubmit}>
				{ this.state.isLoading && <LoadingSpinner /> }
				{ this.state.error && <div className="alert alert-danger">{__( "Could not load settings: ") + this.state.errorMsg}</div> }
				<div className="form-group form-check">
					<input type="checkbox" name="wants_to_be_reviewer"
					disabled={!this.state.isNominatedReviewer}
					checked={this.state.isNominatedReviewer && this.state.wants_to_be_reviewer}
					onChange={this.handleChange}
					className="form-check-input" id="suggested-reviewer"/>
					<label className="form-check-label" htmlFor="suggested-reviewer">{__('I want to be suggested as a page reviewer.')}</label>
				</div>
				<div className="form-group form-check">
					<input type="checkbox" name="wants_to_be_responsible"
					disabled={!this.state.isNominatedResponsible}
					checked={this.state.isNominatedResponsible && this.state.wants_to_be_responsible}
					onChange={this.handleChange}
					className="form-check-input" id="suggested-responsible"/>
					<label className="form-check-label" htmlFor="suggested-responsible">{__('I want to be suggested as a page responsible.')}</label>
				</div>
				<button className="btn btn-primary" type="submit">{__( 'Save' )}</button>
			</form>
		);
	};
}

export default SuggestedListSettings;